module.exports = __webpack_public_path__ + "static/media/logo.70ef1988.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 74
// module chunks = 0